// extracted by mini-css-extract-plugin
export default {"header":"App_header__G9FVm","body":"App_body__YebaT","dark":"App_dark__x6MeM","markdown":"App_markdown__CcRHL"};